import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import logoNearby from '../../images/talentsense-logo-1.jpeg';

export default function ReportHeader({ tr }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 8, gap: 1 }}>

            {/* Logo TalentSense */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
                <img src={logoNearby} alt="TalentSense" style={{ display: 'block', height: 125, width: 'auto', flexShrink: 0 }} />
            </Box>

            {/* Título */}
            <Typography sx={{
                fontSize: '35px',
                fontWeight: 600,
                letterSpacing: '-0.528px',
                lineHeight: '46px',
                color: 'text.primary',
            }}>
                {tr('cap_estimation')}
            </Typography>

        </Box>
    );
}
